import React from "react";

const Error404 = () => {
    return (
        <div className="mt-5 pt-5 mb-5 pb-5 text-center colorNegro text-uppercase">
            <h1>ERROR 404</h1>
            <h2 className="mt-5 pt-5 mb-5 pb-5">La pagina que estas buscando no existe</h2>
        </div>
    )
}

export default Error404;